// import { initializeApollo, addApolloState } from "@/lib/apollo";
// import { gql, NetworkStatus } from "@apollo/client";
import TokenPurchase from "@/seed/components/modules/progress/token-purchase";
import TokenPurchaseClose from "@/seed/components/modules/progress/token-purchase-close";
import TokenPurchaseSuccess from "@/seed/components/modules/progress/token-purchase-success";
import UpComing from "@/seed/components/modules/progress/upcoming";
import WhitelistClose from "@/seed/components/modules/progress/whitelist-close";
import WhitelistFail from "@/seed/components/modules/progress/whitelist-fail";
import WhitelistOpen from "@/seed/components/modules/progress/whitelist-open";
import WhitelistWin from "@/seed/components/modules/progress/whitelist-win";
import * as Timeline from "@/seed/constants/timeline";
import PoolState from "@/seed/contexts/pool/pool-state";
import { useEffect, useState } from "react";

// export async function getStaticProps() {
//     const apolloClient = initializeApollo();

//     await apolloClient.query({
//         query: ALL_POOL_QUERY,
//         variables: {},
//     });

//     return addApolloState(apolloClient, {
//         props: {},
//         revalidate: 1,
//     });
// }

const renderSaleRoundLayout = (currentStep) => {
    console.log("renderSaleRoundLayout", currentStep);
    switch (currentStep) {
        // 1. Upcomming Phrase:
        case Timeline.STEP_START:
        case Timeline.STEP_UPCOMING:
            return <UpComing />;

        // 2. Whitelist Phrase:
        case Timeline.STEP_WHITELIST_APPLIED:
        // TODO: check whitelist be applied
        // return <WhitelistApplied />;

        case Timeline.STEP_WHITELIST:
            return <WhitelistOpen />;

        case Timeline.STEP_WHITELIST_WIN:
            return <WhitelistWin />;

        case Timeline.STEP_WHITELIST_FAIL:
            return <WhitelistFail />;

        case Timeline.STEP_WHITELIST_CLOSE:
            return <WhitelistClose />;

        // 3. Purchasing Phrase:
        case Timeline.STEP_PURCHASE:
        case Timeline.STEP_PURCHASE_START:
            return <TokenPurchase />;

        case Timeline.STEP_PURCHASE_SUCCESS:
            return <TokenPurchaseSuccess />;

        // 4. Sale Closed Phrase:
        case Timeline.STEP_PURCHASE_CLOSE:
            return <TokenPurchaseClose />;

        default:
            return <></>;
    }
};

const SeedSalePage = () => {
    // const appContext = useContext(AppContext);
    // console.log({ appContext });
    const [currentStep, setCurrentStep] = useState(Timeline.STEP_START);

    useEffect(() => {}, []);

    useEffect(() => {
        console.log("SeedSalePage", { currentStep });
    }, [currentStep]);

    // const { loading, error, data, networkStatus } = useQuery(ALL_POOLS_QUERY, {
    //     variables: allPoolsQueryVars,
    //     // Setting this value to true will make the component rerender when
    //     // the "networkStatus" changes, so we are able to know if it is fetching
    //     // more data
    //     notifyOnNetworkStatusChange: true,
    // });

    // console.log("poolEvents", { data, error, loading });

    // if (error) return <ErrorMessage message="Error loading Pools." />;
    // if (loading) return <div>Loading</div>;

    // const { poolEvents } = data;

    // console.log({ poolEvents });
    // 
    return (
        <>
            <PoolState
                currentTimeline={currentStep}
                updateTimelineStep={setCurrentStep}
            >
                {renderSaleRoundLayout(currentStep)}
            </PoolState>
        </>
    );
};

export default SeedSalePage;
